<p-dialog [(visible)]="showModal" [style]="{width: '75vw'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div style="position: absolute; top: 10px; right: 25px; z-index: 9999;"><a style="cursor: pointer" (click)="close()"><img
        src="./assets/images/close.svg" width="16" class="filter-invert" /></a></div>
  <div style="padding: 16px; padding-top: 24px;" *ngIf="model != null">
    <div>
      <div *ngIf="showHeader" class="medium large-text">Location Details</div>
      <div *ngIf="showHeader" style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
    </div>

    <div class="row">
      <div class="col-12">

      </div>
    </div>
    <div class="row">
      <div class="col-6">

        <div class="medium medium-text" style="padding-top: 10px">Location Details</div>
        <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
        <div>
          <table class="detail-table">
            <th id="location-detail-location-details" class="th-display-none"></th>
            <tbody>
              <tr>
                <td>{{metadata['businessName']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.businessName"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['businessHours']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.businessHours"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['phone']}}</td>
                <td>
                  <dynamic-value [type]="'phone'" [value]="model.phone"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['address1']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.address1" display="block"></dynamic-value>
                  <dynamic-value [type]="'text'" [value]="model.city"></dynamic-value>, <dynamic-value [type]="'text'"
                    [value]="model.stateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'" [value]="model.zip">
                  </dynamic-value>
                </td>
              </tr>
              <tr>
                <td>Contact &amp; Phone:</td>
                <td>
                  <contacts-detail [model]="model.contacts"></contacts-detail>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-6">
        <notes-detail [entityName]="'location'" [entityId]="model.id" [showAdd]="showNotesAdd"></notes-detail>
      </div>
    </div>
  </div>
</p-dialog>
